<template>
  <div class="infowindow-wrapper">
    <div class="label">
      {{ business.label }}
    </div>
    <div class="address">
      {{ business.address }}
      <br>
      {{ business.postal_code }} {{ business.city && business.city.label }}
    </div>
    <div class="hours">
      {{ weekdaysTxt }}
      <br>
      {{ weekendsTxt }}
    </div>
    <div class="clickable-txt">
      <svg>
        <use xlink:href="#icon-phone"></use>
      </svg>
      <div
        @click="phoneVisible = true"
        v-if="!phoneVisible"
      >
        {{ $t('commons.show_phone') }}
      </div>
      <div v-else>
        Tél&nbsp;:{{ business.phone }}
        <br>
        <template v-if="business.fax">
          Fax&nbsp;:{{ business.fax }}
          <br>
        </template>
      </div>
    </div>
    <div class="buttons">
      <rent-button
        v-if="showLink"
        class="button"
        grey
        is-anchor
        :href="`/agences/${business.slug}`"
      >
        {{ $t('commons.details') }}
      </rent-button>
      <rent-button
        class="button"
        :loading="loading"
        @buttonclicked="onSelect"
      >
        {{ actionButtonTxt }}
      </rent-button>
    </div>
  </div>
</template>
<script>
import businessHours from '../mixins/businessHours'
import RentButton from '../RentButton'

export default {
  name: 'InfoWindowContent',
  mixins: [businessHours],
  components: {
    RentButton,
  },
  data() {
    return {
      phoneVisible: false,
      loading: false,
    }
  },
  props: {
    business: {
      type: Object,
      default: null,
    },
    showLink: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    actionButtonTxt() {
      return this.isSelectedBusiness
        ? this.$t('commons.continue')
        : this.$t('commons.select')
    },
    storeVehicle() {
      return this.$store.state.vehicles.set.storeVehicle
    },
    datesAndBusinessReady() {
      return this.$store.getters['booking/datesAndBusinessReady']
    },
    canGoToQuotation() {
      return this.storeVehicle && this.datesAndBusinessReady
    },
  },
  methods: {
    onSelect() {
      this.$store.commit('booking/SET_PICKUP_BUSINESS', this.business)
      this.loading = true
      if (this.canGoToQuotation) {
        return this.$store.dispatch('stepping/VALIDATE_STEP_1')
      }
      this.$store.commit('stepping/SET_CURRENT_STEP', 1)
      this.$store.commit('stepping/TRIGGER_STEP_NAVIGATION', { step: 1 })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../sass/config/vars';
@import '../../../../sass/config/mixins';
@import '../../../../sass/config/responsive';

.infowindow-wrapper {
  color: $c-boulder;
  font-family: $f-graphie-book;
  padding: 10px;

  @include font-size(11px);
}

.label {
  color: black;
  font-family: $f-graphie-bold;
  margin: 0 0 5px;
  text-transform: uppercase;

  @include font-size(13px);
}

.address {
  font-family: $f-graphie-bold;
}

svg {
  height: 18px;
  margin: 0 10px 0 0;
  width: 15px;
}

.clickable-txt {
  @include font-size(13px);

  align-items: center;
  color: black;
  display: flex;
  margin: 10px 0;
  text-decoration: underline;
}

.button {
  & + & {
    margin: 10px 0 0;
  }
}
</style>
